var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"dealer-locator__filter"},[_c('h3',{staticClass:"dealer-locator__filter--title"},[_vm._v(_vm._s(_vm.title))]),_vm._v(" "),_c('div',{staticClass:"dealer-locator__filter--content"},[_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }